export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नाम:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सहेजें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["वापस"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कृपया संपत्ति के लिए एक नया नाम प्रदान करें"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["यह नाम आपको अपनी संपत्ति सूची में वॉलेट को आसानी से पहचानने में मदद करेगा।"])}
}